module.exports = __webpack_public_path__ + "media/images/icone_lupa-051dbe1dbd06dba2350e191868a9fcf0.svg";